module.exports = __webpack_public_path__ + "VAGRoundedStd-Black.89d74c51cac5b75e0bd4.otf";


//////////////////
// WEBPACK FOOTER
// /var/www/minhaloga-cliente/src/app/@theme/fontes/fonte-vag-rounded/VAGRoundedStd-Black.otf
// module id = ../../../../../src/app/@theme/fontes/fonte-vag-rounded/VAGRoundedStd-Black.otf
// module chunks = styles